import React from "react";

const SectionHeader = (props) => {
  return (
    <div className={`${props.className} sectionHeaderContainer`} >
      <h2 dangerouslySetInnerHTML={{ __html: props.title }}></h2>
      {props.linkDescription ? <p dangerouslySetInnerHTML={{__html: props.linkDescription}}></p> : <p>{props.description}</p>}
    </div>
  )
}

export default SectionHeader;
